import { Injectable, inject, signal } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

import { ApiService } from './api.service';
import { PsDelivery } from '../models/cart.model';

/**
 * Cliente para el catálogo de Delivery del backend. Hoy solo cubre el
 * Delivery con id=1, que el backend usa como referencia para `home`
 * (precio fijo + umbral de envío gratis). `ps_delivery` se cotiza al
 * recibir el pedido y no usa este precio en la UI.
 *
 * El cart ya trae `ps_delivery` embebido en `/get-cart-by-token`, así que
 * checkout no necesita este service. Lo consume el modal de precompra,
 * que no tiene cart context.
 */
@Injectable({ providedIn: 'root' })
export class DeliveryService {
  private readonly api = inject(ApiService);

  private readonly _delivery1 = signal<PsDelivery | null>(null);
  readonly delivery1 = this._delivery1.asReadonly();

  /**
   * Carga el Delivery id=1 y lo cachea en memoria. Llamadas posteriores
   * devuelven el valor cacheado sin tocar la red. La cache vive hasta
   * recargar la app — suficiente porque el delivery cambia con poca
   * frecuencia y el backend no expone invalidación.
   */
  loadDelivery1(): Observable<PsDelivery> {
    const cached = this._delivery1();
    if (cached) return of(cached);

    return this.api
      .get<PsDelivery>('/show-web-delivery/1')
      .pipe(tap((delivery) => this._delivery1.set(delivery)));
  }
}
